import React from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import { lassoForm } from '@bd/bdui-forms';
import { Redirect } from '@bd/bdcore-named-routes';
import { css } from '@bd/bdui-styles/emotion';
import Fields from './Fields';
import { colors } from '../../styles';


const styles = css`
  .Form__missingField {
    background-color: yellow;
    padding: 5px;
    color: black;
  }
  .form-row {
    margin:0 -5px;
  }
  .form-col {
  width:100%;
  padding:5px;

  @media (min-width: 480px) {
      width:50%;
    }
    }
    .form-col-fluid {
    width:100%;
    padding:5px;
    }
    label {
    font-weight: 700;
    font-size: 16px;
    color: ${colors.body};
    .required {
      color: ${colors.error};
    }
    }
    .invalid-feedback {
    display: block;
    min-height:20px;
    }
    .form-control.is-invalid, .form-control.is-valid {
    background-image:none;
    }
    .fieldOptional {
    input {
      // border-color:inherit !important;
    }
    }
    .FormSectionHeading {
    font-weight:700;
    font-size:18px;
    width:100%;
    text-transform:uppercase;
    padding-bottom:5px;
    color:${colors.brand2};
    border-bottom:1px solid ${colors.whiteDarkest};
    }
`;

class FormContact extends React.Component {
  constructor(props) {
    super(props);

    const { formApi, formName, formLabel } = props;

    formApi.setValue('formName', formName);
    formApi.setValue('formLabel', formLabel);

    this.state = {};
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.success && !this.props.success) {
      this.props.onSuccess();
    }
  }

  getError = field => {
    const { formApi } = this.props;
    return get(formApi, `touched.${field}`) && get(formApi, `errors.${field}`);
  }

  getErrorClass = field => {
    const { formApi } = this.props;
    if (get(formApi, `touched.${field}`) && get(formApi, `errors.${field}`)) {
      return 'is-invalid';
    }

    return null;
  }

  render() {
    const { className, success, redirectRoute, fields, formApi } = this.props;

    if (success) {
      return (
        <div>
          {
            redirectRoute &&
            <Redirect
              name={redirectRoute}
            />
          }
          {
            !redirectRoute &&
            <div style={{ color: '#333333' }}>
              <h4>Thank You</h4>
              <p>
                We have received your message and will respond as soon as possible.
              </p>
            </div>
          }
        </div>
      );
    }

    return (
      <div className={[styles, className].filter(v => v).join(' ')}>
        <div className="form-row">
          {
            fields.map(config => {
              const FieldComponent = Fields[config.type];
              if (!FieldComponent) {
                return (
                  <div className="form-col" key={config.label}>
                    <label htmlFor="missing">{config.label}</label>
                    <div className="Form__missingField">{`Field type "${config.type}" does not exist`}</div>
                  </div>
                );
              }
              return (
                <FieldComponent
                  {...config}
                  key={config.label}
                  getErrorClass={this.getErrorClass}
                  getError={this.getError}
                  formApi={formApi}
                />
              );
            })
          }
        </div>
        <div className="Button_wrapper">
          <button type="submit" className="btn btn-brand1">Submit<span className="ArrowButton_image" /></button>
        </div>
      </div>
    );
  }
}

FormContact.propTypes = {
  className: PropTypes.string,
  formName: PropTypes.string.isRequired,
  formLabel: PropTypes.string.isRequired,
  formApi: PropTypes.object.isRequired,
  success: PropTypes.bool,
  onSuccess: PropTypes.func,
  redirectRoute: PropTypes.string,
  fields: PropTypes.arrayOf(PropTypes.object).isRequired,
};

FormContact.defaultProps = {
  className: undefined,
  success: undefined,
  onSuccess: () => {},
  redirectRoute: undefined,
};

export default lassoForm()(FormContact);



// WEBPACK FOOTER //
// ./src/components/Forms/Form.js